<template>
  <div class="quality">
    <div class="title">
      <p class="en">Construction quality</p>
      <p class="cn">{{$t("home.quality.title")}}</p>
    </div>
    <div class="container">
      <div class="icons">
        <router-link to="/quality">
          <div class="wrapper">
            <div class="item">
              <div class="icon">
                <img src="~assets/home/quality-buy.png"/>
              </div>
              <p class="icon-name">{{$t("home.quality.ico2")}}</p>
            </div>
          </div>
        </router-link>
        <router-link to="/quality/design">
          <div class="wrapper">
            <div class="item">
              <div class="icon">
                <img src="~assets/home/quality-design.png"/>
              </div>
              <p class="icon-name">{{$t("home.quality.ico1")}}</p>
            </div>
          </div>
        </router-link>
        <router-link to="/quality/work">
          <div class="wrapper">
            <div class="item">
              <div class="icon">
                <img src="~assets/home/quality-work.png"/>
              </div>
              <p class="icon-name">{{$t("home.quality.ico3")}}</p>
            </div>
          </div>
        </router-link>
        <router-link to="/quality/test">
          <div class="wrapper">
            <div class="item">
              <div class="icon">
                <img src="~assets/home/quality-test.png"/>
              </div>
              <p class="icon-name">{{$t("home.quality.ico4")}}</p>
            </div>
          </div>
        </router-link>
        <router-link to="/quality/serve">
          <div class="wrapper">
            <div class="item">
              <div class="icon">
                <img src="~assets/home/quality-serve.png"/>
              </div>
              <p class="icon-name">{{$t("home.quality.ico5")}}</p>
            </div>
          </div>
        </router-link>
      </div>
      <div class="desc">
        <div class="text design" v-html="$t('home.quality.text1')"></div>
        <div class="text buy" v-html="$t('home.quality.text2')"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'News',
  data () {
    return {
      activeName: 'second'
    }
  },
  computed: {
  },
  mounted () {
  },
  methods: {
    handleClick (tab, event) {
      console.log(tab, event)
    }
  }
}
</script>

<style scoped lang="stylus">
  @import "~styles/varibles"
  @import "~styles/mixins"
  .title
    width 100%
    text-align center
    padding-bottom 72px
    .en
      en()
      font-size 40px
    .cn
      cn()
      font-size 24px
  $polygon8-width = 110px
  $polygon8-height = $polygon8-width*1.732
  .quality
    background #f7f8fa
    padding 83px 1.75% 83px 1.75%
    .container
      position relative
      .icons
        flexCenter()
        .wrapper
          margin 0 65px
          .item:before
            polygon8before()
            width $polygon8-width
            height $polygon8-height
          .item:after
            pxpolygon8after()
            width $polygon8-width
            height $polygon8-height
          .item:hover,.item:hover:before,.item:hover:after
            background $navBgColor2
          .item
            polygon8()
            width $polygon8-width
            height $polygon8-height
            .icon
              position absolute
              top 30px
              left 0
              width 100%
              z-index 1
            .icon-name
              position absolute
              bottom 10px
              left 0
              width 100%
              z-index 1
              cn()
              font-size 24px
              color #FFF
              text-align center
      .desc
        display none
        position relative
        bottom 0
        left 0
        width 100%
        setHeight()
        padding-bottom 30%
        font-size 15px
        line-height 40px
        text-align center
        font-family "Source Han Sans CN Normal"
        .text
          position absolute
          top 0
          left 0
          padding-top 40px
          opacity 0
          transition opacity 0.5s
        .design
          opacity 1
</style>



// WEBPACK FOOTER //
// src/pages/home/components/Quality.vue